import SummaryEmployeeRequest from "../../summary-employee-request";
import { Create } from "../../summary-employee-request/pages/create";
import { Detail } from "../../summary-employee-request/pages/detail";

export const summaryEmployeeRequestRoutes = {
  summaryEmployeeRequestPage: {
    isAdmin: false,
    title: "6. Bảng tổng hợp nhân sự tham gia khóa học",
    path: "/procedure/person-registered-course",
    parentId: "procedure",
    component: SummaryEmployeeRequest,
  },
  summaryEmployeeRequestCreatePage: {
    isAdmin: false,
    title: "6. Bảng tổng hợp nhân sự tham gia khóa học",
    path: "/procedure/person-registered-course/create/:id",
    parentId: "procedure",
    component: Create,
  },
  summaryEmployeeRequestDetailPage:{
    isAdmin: false,
    title: "4. Đơn xin nghỉ phép",
    path: "/procedure/person-registered-course/details/:id",
    parentId: "procedure",
    component:Detail,
  }
};